const defaultCustomer = {
    is_fb_user: false,
    is_fb_transitioned: false,
    is_lounge_first_user: true,
    email: '',
};
export const isUserTransitioned = ({ is_fb_transitioned: isTransitioned, } = defaultCustomer) => !!isTransitioned;
export const isFacebookUser = ({ is_fb_user: isCustomerLoggedInWithFacebook, } = defaultCustomer) => isCustomerLoggedInWithFacebook;
export const isZalandoFashionStoreUser = ({ is_lounge_first_user: isLoungeFirstUser, } = defaultCustomer) => !isLoungeFirstUser;
export const hasCustomerData = (customer) => customer && customer.email;
//# sourceMappingURL=customer.js.map